import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ModalService } from '../../data-access/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [CommonModule],
  standalone: true,
})
export class ModalComponent implements OnInit {
  modalService = inject(ModalService);

  @Input() modalId!: string;
  @Output() closeModal = new EventEmitter<void>();
  
  isOpen$!: Observable<boolean>;

  ngOnInit() {
    this.isOpen$ = this.modalService.getModalState(this.modalId);
  }

  close() {
    this.closeModal.emit();
  }
}
